var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgALogoXingOriginalColored24 = function SvgALogoXingOriginalColored24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67131 4.63432L5.50099 9.65032L1.27002 17.0485H6.31389L10.517 9.65032L7.68654 4.63432H2.67131Z",
    fill: "#0698A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6884 0L9.53076 14.4341L14.7906 24H19.9111L14.5661 14.4341L22.7246 0H17.6884Z",
    fill: "#B7DF4B"
  })));
};
export { SvgALogoXingOriginalColored24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjY3MTMxIDQuNjM0MzJMNS41MDA5OSA5LjY1MDMyTDEuMjcwMDIgMTcuMDQ4NUg2LjMxMzg5TDEwLjUxNyA5LjY1MDMyTDcuNjg2NTQgNC42MzQzMkgyLjY3MTMxWiIgZmlsbD0iIzA2OThBMCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjY4ODQgMEw5LjUzMDc2IDE0LjQzNDFMMTQuNzkwNiAyNEgxOS45MTExTDE0LjU2NjEgMTQuNDM0MUwyMi43MjQ2IDBIMTcuNjg4NFoiIGZpbGw9IiNCN0RGNEIiLz4KPC9zdmc+Cg==";